import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#292524] text-white py-16" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-12">
          {/* Brand Column */}
          <div>
            <span className="font-heading text-2xl font-semibold">
              Said<span className="text-[#0D9488]">Simply</span>™
            </span>
            <p className="mt-4 text-stone-400 text-sm leading-relaxed max-w-xs">
              Protecting families by translating legal chaos into peace of mind.
            </p>
          </div>

          {/* Legal Links */}
          <div data-testid="footer-legal">
            <h4 className="font-medium text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-stone-400 hover:text-white transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-stone-400 hover:text-white transition-colors text-sm">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-stone-700 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-400 text-sm">
            © {new Date().getFullYear()} SaidSimply™, a service of Concepts.io LLC. All rights reserved.
          </p>
          <p className="text-stone-400 text-sm flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-red-400 fill-red-400" /> for families everywhere
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
